import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

import {
  Column,
  ColumnName,
  ColumnValue,
  Container,
  Content,
  ErrorMessage,
  Grid,
  Row,
} from './styles';

const PastStudies = (props) => {
  const pastStudies = props.pastStudies.reduce((attributes, current) => {
    if (!_.isEmpty(current.testSessions) && current.testSessions[0].status !== 'pending') {
      return [
        ...attributes,
        <Container>
          <Content key={current.id}>
            <Grid>
              <Row>
                <Column weight={500} width={3}>
                  <ColumnName>
                    Company
                  </ColumnName>
                </Column>
                <Column width={12}>
                  <ColumnValue>
                    {current.project.company.name}
                  </ColumnValue>
                </Column>
              </Row>
              <Row>
                <Column weight={500} width={3}>
                  <ColumnName>
                    Project
                  </ColumnName>
                </Column>
                <Column width={12}>
                  <ColumnValue>
                    {current.project.name}
                  </ColumnValue>
                </Column>
              </Row>
              <Row>
                <Column weight={500} width={3}>
                  <ColumnName>
                    Description
                  </ColumnName>
                </Column>
                <Column width={12}>
                  <ColumnValue>
                    {current.project.description}
                  </ColumnValue>
                </Column>
              </Row>
              <Row>
                <Column weight={500} width={3}>
                  <ColumnName>
                    Study Type
                  </ColumnName>
                </Column>
                <Column width={12}>
                  <ColumnValue>
                    {current.project.testType}
                  </ColumnValue>
                </Column>
              </Row>
              <Row>
                <Column weight={500} width={3}>
                  <ColumnName>
                    Completed date
                  </ColumnName>
                </Column>
                <Column width={12}>
                  <ColumnValue>
                    {moment(current.testSessions[0].completed_at).format('L')}
                  </ColumnValue>
                </Column>
              </Row>
              <Row>
                <Column weight={500} width={3}>
                  <ColumnName>
                    Payment Amount
                  </ColumnName>
                </Column>
                <Column width={12}>
                  <ColumnValue>
                    $
                    {Number(current.paymentValue).toFixed(2)}
                  </ColumnValue>
                </Column>
              </Row>
            </Grid>
          </Content>
        </Container>,
      ];
    }

    return attributes;
  }, []);

  if (_.isEmpty(pastStudies)) {
    return <Container><ErrorMessage>No studies for this tester</ErrorMessage></Container>;
  }
  return (pastStudies);
};

PastStudies.propTypes = {
  pastStudies: PropTypes.array.isRequired,
};

export default PastStudies;
